module.exports = __webpack_public_path__ + "img/logo.09c78c82.png";